// extracted by mini-css-extract-plugin
export default {"form":"QuickActionsAndContact_form__3gjW7","formTitle":"QuickActionsAndContact_formTitle__3XM-2"};